module.exports = __webpack_public_path__ + "img/Ute_Side_Right.105f1a88.svg";